import { useNavigate } from "react-router-dom";

export default function Dropdown({
  menuKey,
  menu,
  projectId,
  toggleMenu,
  openMenu,
  isLast,
}) {
  const navigate = useNavigate();

  const base =
    typeof menu.base === "function" ? menu.base(projectId) : menu.base;

  const sections = menu.sections ?? [];

  const handleBaseClick = () => {
    const base = menu.base(projectId);
    const baseClick = menu.baseClick;

    if (baseClick) {
      navigate(`${base}/${baseClick}`);
    } else {
      navigate(base);
    }

    toggleMenu(null);
  };

  return (
    <div
      className="menu-root relative"
      onMouseEnter={() => toggleMenu(menuKey)}
      onMouseLeave={() => toggleMenu(null)}
    >
      {/* 상단 메뉴 탭 */}
      <span
        className="menu-trigger cursor-pointer text-white"
        onClick={handleBaseClick}
      >
        {menu.title}
      </span>

      {/* 드롭다운 패널 */}
      {openMenu === menuKey && (
        <div
          className={`absolute top-full bg-white border border-gray-200 shadow-lg min-w-32 text-black z-50 py-2
                    ${
                      isLast
                        ? "right-0 translate-x-0"
                        : "left-1/2 -translate-x-1/2"
                    }
                `}
        >
          {sections.map((section, idx) => {
            const firstItem = section.items?.[0];

            // 첫번째 item 없으면 스킵
            if (!firstItem) return null;

            // 첫 item 링크 추출
            const to =
              typeof firstItem.to === "string"
                ? `${base}/${firstItem.to}`
                : firstItem.to.pathname
                ? `${base}/${firstItem.to.pathname}${firstItem.to.search ?? ""}`
                : base;

            return (
              <div
                key={idx}
                className="px-3 py-2 cursor-pointer hover:bg-gray-100 rounded text-sm "
                onClick={() => {
                  navigate(to);
                  toggleMenu(null);
                }}
              >
                {/* {console.log("Dropdown rendering:", section.title)} */}
                {section.title}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
